var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('Button',{staticClass:"p-button-text p-button-rounded p-button-secondary",attrs:{"type":"button","icon":"pi pi-ellipsis-v","aria-haspopup":"true","aria-controls":"overlay_menu"},on:{"click":_vm.toggle}}),_c('Menu',{ref:"menu",attrs:{"id":"overlay_menu","model":_vm.items,"popup":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }